import { Tag } from "@blueprintjs/core";
import React from "react";
import { copyToClipboard } from "../fns/util";

class ClickToCopy extends React.Component {
  render() {
    return (
      <Tag
        minimal={this.props.minimal}
        rightIcon="duplicate"
        interactive
        onClick={() => copyToClipboard(this.props.text)}
      >
        {this.props.text}
      </Tag>
    );
  }
}

export default ClickToCopy;
